import { render, staticRenderFns } from "./ProfilePassAcceptButtons.vue?vue&type=template&id=416e21ba&scoped=true"
import script from "./ProfilePassAcceptButtons.vue?vue&type=script&lang=js"
export * from "./ProfilePassAcceptButtons.vue?vue&type=script&lang=js"
import style0 from "./ProfilePassAcceptButtons.vue?vue&type=style&index=0&id=416e21ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e21ba",
  null
  
)

export default component.exports